export const getHowToCreateAnchorUrl = () => `https://knowledge.hubspot.com/articles/kcs_article/cos-pages-editor/insert-and-manage-anchor-links-to-your-blog-posts-pages-and-knowledge-base-articles`;
export const isValidAnchorId = id => {
  // Follows HTML4 rules: https://www.w3.org/TR/html401/types.html#type-id
  return id.length > 0 && /^[A-Za-z][A-Za-z0-9\-:._]*$/.test(id);
};
export const serializeAnchorAsLink = anchor => `#${anchor}`;
export const deserializeAnchorFromLink = anchorLink => {
  if (anchorLink.startsWith('#')) {
    return anchorLink.substring(1);
  }
  return anchorLink;
};